interface StorySectionProps {
  brandName: string
  mission: string
  description: string
}

export default function StorySection({
  brandName,
  mission,
  description
}: StorySectionProps) {
  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 reveal">
      <div className="max-w-4xl mx-auto text-center">
        <div className="space-y-4 sm:space-y-6">
          <h2 className="playfair-header text-3xl sm:text-4xl md:text-5xl text-foreground">
            {brandName} // THE STORY
          </h2>
          <p className="text-lg sm:text-xl text-foreground/80 font-light leading-relaxed">
            {mission}
          </p>
          <p className="text-base sm:text-lg text-foreground/70 leading-relaxed max-w-2xl mx-auto">
            {description}
          </p>
        </div>
      </div>
    </section>
  )
}